if (!customElements.get('cart-policy-acknowledgement')) {
  customElements.define(
    'cart-policy-acknowledgement',
    class CartPolicyAcknowledgement extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.storageKey = 'lapidaryMartCartPolicyAgreement';
        this.checkbox = this.querySelector('[data-cart-policy-checkbox]');
        this.acceptedAt = this.querySelector('[data-cart-policy-accepted-at]');
        this.error = this.querySelector('[data-cart-policy-error]');
        this.form = document.getElementById(this.dataset.formId);
        this.checkoutButton = document.getElementById(this.dataset.checkoutButtonId);

        if (!this.checkbox || !this.form || !this.checkoutButton) return;

        if (Number.parseInt(this.dataset.cartItemCount, 10) === 0) this.clearSavedAgreement();

        this.dataset.initialized = 'true';
        this.handleChange = this.handleChange.bind(this);
        this.requireAgreement = this.requireAgreement.bind(this);

        const savedAgreement = window.lapidaryMartCartPolicyAgreement || this.readSavedAgreement();
        if (savedAgreement) {
          this.checkbox.checked = savedAgreement.agreed;
          if (this.acceptedAt) this.acceptedAt.value = savedAgreement.acceptedAt;
          window.lapidaryMartCartPolicyAgreement = savedAgreement;
        } else {
          const checkedAgreement = document.querySelector('[data-cart-policy-checkbox]:checked');
          if (checkedAgreement && checkedAgreement !== this.checkbox) this.checkbox.checked = true;

          if (this.checkbox.checked) {
            this.saveAgreementLocally({
              agreed: true,
              acceptedAt: this.acceptedAt ? this.acceptedAt.value : '',
            });
          }
        }

        this.checkbox.addEventListener('change', this.handleChange);
        this.form.addEventListener('submit', this.requireAgreement, true);
        this.syncButton();
      }

      disconnectedCallback() {
        if (!this.checkbox || !this.form) return;

        this.checkbox.removeEventListener('change', this.handleChange);
        this.form.removeEventListener('submit', this.requireAgreement, true);
        delete this.dataset.initialized;
      }

      handleChange() {
        const agreed = this.checkbox.checked;
        const acceptedAt = agreed ? new Date().toISOString() : '';

        this.saveAgreementLocally({ agreed, acceptedAt });

        document.querySelectorAll('[data-cart-policy-checkbox]').forEach((checkbox) => {
          checkbox.checked = agreed;
        });

        document.querySelectorAll('[data-cart-policy-accepted-at]').forEach((timestamp) => {
          timestamp.value = acceptedAt;
        });

        document.querySelectorAll('cart-policy-acknowledgement').forEach((agreement) => {
          if (agreement.error) agreement.error.hidden = true;
          if (agreement.syncButton) agreement.syncButton();
        });

        this.persistAgreement(agreed, acceptedAt);
      }

      readSavedAgreement() {
        try {
          const savedAgreement = window.sessionStorage.getItem(this.storageKey);
          return savedAgreement ? JSON.parse(savedAgreement) : null;
        } catch (error) {
          return null;
        }
      }

      saveAgreementLocally(agreement) {
        window.lapidaryMartCartPolicyAgreement = agreement;

        try {
          window.sessionStorage.setItem(this.storageKey, JSON.stringify(agreement));
        } catch (error) {
          // The in-memory copy still preserves the state during this page visit.
        }
      }

      clearSavedAgreement() {
        delete window.lapidaryMartCartPolicyAgreement;

        try {
          window.sessionStorage.removeItem(this.storageKey);
        } catch (error) {
          // Storage can be unavailable in some privacy modes.
        }
      }

      persistAgreement(agreed, acceptedAt) {
        const cartUpdateUrl = window.routes?.cart_update_url || '/cart/update.js';
        const attributes = {
          'Cancelation & Returns Policy Accepted': agreed ? this.checkbox.value : '',
          'Cancelation & Returns Policy URL': agreed ? 'https://www.lapidarymart.com/pages/returns' : '',
          'Cancelation & Returns Policy Accepted At': acceptedAt,
        };

        const previousUpdate = window.lapidaryMartCartPolicyUpdate || Promise.resolve();
        window.lapidaryMartCartPolicyUpdate = previousUpdate
          .catch(() => {})
          .then(() =>
            fetch(cartUpdateUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ attributes }),
            })
          )
          .then((response) => {
            if (!response.ok) throw new Error(`Cart policy update failed with status ${response.status}`);
            return response.json();
          })
          .catch((error) => console.error(error));
      }

      syncButton() {
        if (!this.checkoutButton) return;

        if (!this.checkbox.checked) {
          if (!this.checkoutButton.disabled) this.checkoutButton.dataset.disabledByPolicy = 'true';
          this.checkoutButton.disabled = true;
          this.checkoutButton.setAttribute('aria-disabled', 'true');
          return;
        }

        if (this.checkoutButton.dataset.disabledByPolicy === 'true') {
          this.checkoutButton.disabled = false;
          this.checkoutButton.removeAttribute('aria-disabled');
          delete this.checkoutButton.dataset.disabledByPolicy;
        }
      }

      requireAgreement(event) {
        if (this.checkbox.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.error) this.error.hidden = false;
        this.checkbox.focus();
        this.syncButton();
      }
    }
  );
}
